module.exports = __webpack_public_path__ + "static/media/Financial Assistance_B.e7e972a3.png";